import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/activity.svg'


const _hoisted_1 = { class: "w-full md:w-[300px] border border-gray-400 rounded" }
const _hoisted_2 = { class: "capitalize" }
const _hoisted_3 = { class: "flex items-center object-fill w-full h-64 overflow-clip" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  src: _imports_0
}
const _hoisted_6 = { class: "p-4 border-t" }
const _hoisted_7 = { class: "mb-2 text-xl font-medium leading-none" }
const _hoisted_8 = { class: "leading-1" }

import { PropType } from "vue";
import { storeToRefs } from "pinia";

import RouterButton from "@/components/RouterButton.vue";

import { Resource } from "@/types";
import { useUserStore } from "@/store";
import { getUsersHighestRole } from "@/utils/roles";
import { slugify } from "@/utils/slugify";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceCard',
  props: {
  resource: {
    type: Object as PropType<Resource>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();

const { user } = storeToRefs(useUserStore());



function formatHeader() {
  const role = getUsersHighestRole(user.value.roles).display_name;

  const isAdmin = role.includes("Admin") && !role.includes("Group Admin");

  let display_role = role;

  if (isAdmin) {
    // Get the resource role from the resource object
    let roles = [...props.resource.roles].sort((a, b) => a.order - b.order);
    display_role = roles[0] ? roles[0].display_name : "Admin";
  }

  if (display_role === "Advanced Facilitator Trainee") {
    return "Certified Facilitator";
  }

  if (display_role.toLowerCase() === "level 04a trainee" || display_role.toLowerCase() === "trainee trainer") {
    return "Advanced Facilitator";
  }

  return t(slugify(display_role));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["px-4 py-2 rounded-t", [__props.resource.roles === undefined ? 'bg-play-green text-white' : 'bg-play-peach text-black']])
    }, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("resource-card-header", [formatHeader()])), 1)
    ], 2),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        (__props.resource.thumbnail)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: __props.resource.thumbnail,
              class: "w-full"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("img", _hoisted_5))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h5", _hoisted_7, _toDisplayString(__props.resource.title), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString(__props.resource.subtitle), 1),
        _createVNode(RouterButton, {
          to: { name: 'Resource', params: { id: __props.resource.id } },
          type: "primary",
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("view-resource")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})